var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorize = function SvgColorize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.508 20.492v-4.057L12.37 7.57 10.74 5.98l1.084-1.054 2.112 2.102 3.283-3.292a.75.75 0 0 1 .26-.167.85.85 0 0 1 .627 0q.141.06.272.167l1.889 1.898q.105.12.166.262.06.142.06.313 0 .161-.06.315a.75.75 0 0 1-.166.26l-3.287 3.286 2.112 2.152-1.07 1.07-1.611-1.643-8.844 8.844zm1.5-1.5h1.97l8.366-8.417-1.919-1.92-8.417 8.368zm10.906-9.98 2.804-2.804-.925-.925-2.804 2.813z"
  })));
};
export default SvgColorize;